import { render, staticRenderFns } from "./DeviceRequestGetConfig.vue?vue&type=template&id=0bae84de&scoped=true&"
import script from "./DeviceRequestGetConfig.vue?vue&type=script&lang=js&"
export * from "./DeviceRequestGetConfig.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRequestGetConfig.vue?vue&type=style&index=0&id=0bae84de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae84de",
  null
  
)

export default component.exports